import { Injectable } from '@angular/core';
import {map} from "rxjs/operators";
import {IParty} from "@retail-data-factory/rdf-angular-types-api";
import {Observable} from "rxjs";
import {DataService} from "../../../../services/external-api/data.service";
import {Presenter} from "../../../internal/presenter/presenter";
import {ApiService} from "../../../../services/external-api/api.service";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {AssistTranslationService} from "@retail-data-factory/rdf-angular-translation-service";

@Injectable({
  providedIn: 'root'
})
export class ApiIsmService {
  constructor(private dataService: DataService,
              private presenter: Presenter,
              private apiService: ApiService,
              private configurationManager: ConfigurationManager,
              private atService: AssistTranslationService) {
  }

    getIsmCustomerList(distributorId): Observable<Array<IParty>> {
    const url =  `${this.configurationManager.getApiUrl('apiIsmUrl')}/distributors/${distributorId}/cutomers`;
    return this.dataService.getReportData(url, {}).pipe(
      map(
        result => {
          return result.report.map(t => t);
        }
      )
    );
  }



}
